import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { PageNotFound } from "./components";
import { useIsMobile, useScrollToTop } from "./hooks/smallHooks";
import { setupIonicReact } from "@ionic/react";
import { renderProjectRoutes } from "./routes/ProjectRoutes";
import "./theme/general.css";

setupIonicReact();

function App() {
  const location = useLocation();
  const pathname = location?.pathname;
  const isMobile = useIsMobile();
  useScrollToTop();

  return (
    <HelmetProvider>
      <Routes location={location} key={location.pathname}>
        {renderProjectRoutes({ pathname, isMobile })}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </HelmetProvider>
  );
}

export default App;
